/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Note_Not_FoundInputs */

const en_mobile_note_not_found = /** @type {(inputs: Mobile_Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note not found.`)
};

const es_mobile_note_not_found = /** @type {(inputs: Mobile_Note_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota no encontrada.`)
};

/**
* | output |
* | --- |
* | "Note not found." |
*
* @param {Mobile_Note_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_note_not_found = /** @type {((inputs?: Mobile_Note_Not_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Note_Not_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_note_not_found(inputs)
	return en_mobile_note_not_found(inputs)
});